export const SERVICE_CODE = 'SERVICES' + '_SERVICE';
